<template>
  <wx-open-subscribe :template="templateId" id="subscribe-btn" @success="onSuccess" @error="onError" >
    <script type="text/wxtag-template" slot="style">
      <style>
        .subscribe-btn {
          border: 1px solid #35b6a4;
          padding: 4px 5px;
          border-radius: 5px;
          font-size: 11.7px;
          width: fit-content;
          color: #35b6a4;
          background-color: transparent;
        }
      </style>
    </script>
    <script type="text/wxtag-template">
      <button class="subscribe-btn">
        {{ title }}
      </button>
    </script>
  </wx-open-subscribe>
</template>
<script>
import wx from 'weixin-js-sdk'
export default {
  name: 'cWxOpenSubscribeBtn',
  props: {
    title: {
      type: String,
      default: '订阅'
    },
    templateId: {
      type: String,
      default: 'iga9M-4SgD-57e9yomOetWiW8xMa6swb_M_2jadewTk'
    }
  },
  methods: {
    onSuccess(e) {
      this.$emit('success', e)
    },
    onError(e) {
      this.$emit('error', e)
    },
    init () {
      this.$emit('ready')
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.init()
    })
  }
}
</script>